import ConsejoEstudiantil from './ConsejoEstudiantil';

export default ConsejoEstudiantil;